// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyAOcYN-0jC7NumIkMgXlMDqATp31IpfitU",
    authDomain: "work-mart-9019b.firebaseapp.com",
    projectId: "work-mart-9019b",
    storageBucket: "work-mart-9019b.firebasestorage.app",
    messagingSenderId: "241242610621",
    appId: "1:241242610621:web:a11de61bdf46b9a08490d4",
    measurementId: "G-Y73K2R3CJ9"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
